import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Paper,
  SelectChangeEvent,
} from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';
import { Venue } from '../../types/venue';
import { EventTypeDto } from '../../services/eventService';

interface FilterBarProps {
  selectedVenue: string;
  selectedEventType: string;
  venues: Venue[];
  eventTypes: EventTypeDto[];
  onFilterChange: (venueId: string, eventTypeId: string) => void;
  onClearFilters: () => void;
  loadingVenues?: boolean;
  loadingEventTypes?: boolean;
}

const FilterBar: React.FC<FilterBarProps> = ({
  selectedVenue,
  selectedEventType,
  venues,
  eventTypes,
  onFilterChange,
  onClearFilters,
  loadingVenues = false,
  loadingEventTypes = false,
}) => {
  const handleVenueChange = (event: SelectChangeEvent<string>) => {
    onFilterChange(event.target.value, selectedEventType);
  };

  const handleEventTypeChange = (event: SelectChangeEvent<string>) => {
    onFilterChange(selectedVenue, event.target.value);
  };

  const hasActiveFilters = selectedVenue !== '' || selectedEventType !== '';

  return (
    <Paper sx={{ p: 2 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 2,
          alignItems: { xs: 'stretch', md: 'center' },
        }}
      >
        {/* Venue Filter */}
        <FormControl
          sx={{ minWidth: { xs: '100%', md: 250 } }}
          size="small"
        >
          <InputLabel id="venue-filter-label">Helyszín</InputLabel>
          <Select
            labelId="venue-filter-label"
            value={selectedVenue}
            label="Helyszín"
            onChange={handleVenueChange}
            disabled={loadingVenues}
          >
            <MenuItem value="">
              <em>Összes helyszín</em>
            </MenuItem>
            {venues.map((venue) => (
              <MenuItem key={venue.venueId} value={venue.venueId}>
                {venue.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Event Type Filter */}
        <FormControl
          sx={{ minWidth: { xs: '100%', md: 250 } }}
          size="small"
        >
          <InputLabel id="event-type-filter-label">Esemény típus</InputLabel>
          <Select
            labelId="event-type-filter-label"
            value={selectedEventType}
            label="Esemény típus"
            onChange={handleEventTypeChange}
            disabled={loadingEventTypes}
          >
            <MenuItem value="">
              <em>Összes típus</em>
            </MenuItem>
            {eventTypes.map((eventType) => (
              <MenuItem key={eventType.eventTypeId} value={eventType.eventTypeId}>
                {eventType.displayName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Clear Filters Button */}
        {hasActiveFilters && (
          <Button
            variant="outlined"
            startIcon={<ClearIcon />}
            onClick={onClearFilters}
            sx={{
              alignSelf: { xs: 'flex-start', md: 'auto' },
            }}
          >
            Szűrők törlése
          </Button>
        )}
      </Box>
    </Paper>
  );
};

export default FilterBar;
